import React from 'react';
import { connect } from 'react-redux';
import { buyerUpdate, profileFetch } from '../actions';
import {
  getBuyerFormFields,
  getBuyerFieldFetches,
  getBuyer,
  getProfile
} from '../selectors';
import BuyerInfoView from '../components/BuyerInfoView';

const BuyerInfoContainer = props => <BuyerInfoView {...props} />;

const mapStateToProps = state => ({
  profile: getProfile(state),
  buyer: getBuyer(state),
  buyerFormFields: getBuyerFormFields(state),
  buyerFormFieldFetches: getBuyerFieldFetches(state)
});

const mapDispatchToProps = dispatch => ({
  buyerUpdateAction: (...p) => dispatch(buyerUpdate(...p)),
  profileFetchAction: () => dispatch(profileFetch()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BuyerInfoContainer);
